import React, { useEffect, useState } from "react";
import { getDataFromURI, getNftData } from "../../../hooks/Tokenhook";
import { getURIFromCollection } from "../../../hooks/Collectionhook";
import { contractAddress } from "../../../config/BackendUrl";
import { getNFT, getNFTByTokenId } from "../../../hooks/NFTHook";

const IDOBackground = (props) => {
  const [nftData, setNftData] = useState(null);
  const contractData = props.localData ? props.localData : null;

  useEffect(() => {
    if (!contractData) return; // Do nothing if contractData is null or undefined

    // if (contractData.nftContract === contractAddress) {
    DtocNFT();
    // }
    //  else {
    //   OtherCollectionNFT();
    // }
  }, [contractData]);

  const DtocNFT = async () => {
    const params = {
      contractAddress:contractData.nftContract,
      tokenId:contractData.nftTokenId
    }
    const GFRdata = await getNFTByTokenId(params);
    console.log("GFRdata", GFRdata);
if(GFRdata.success === true){
  setNftData(GFRdata.data[0]); 
}
    // getNftData(contractData.nftTokenId).then(async (data) => {
    //   if (data.status === 200) {
    //     await getDataFromURI(data.data).then((url) => {
    //       setNftData(url.data);
    //     })

    //   }
    // });

  }
  const OtherCollectionNFT = async () => {
    await getURIFromCollection(contractData.nftContract, contractData.nftTokenId).then(async (data) => {
      console.log("Data", data.data);
      const URI = data.data;
      if (URI.status === 200) {
        await getDataFromURI(URI.data).then((url) => {
          setNftData(url.data);
        })

      }

    })
  }

  console.log("contractData", contractData);

  return (
    <div style={{ width: "100%" }}>
      {/* Cover Photo Section */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          background: contractData?.campaignMedia
            ? `url(${contractData?.campaignMedia[0]}) center/cover no-repeat`
            : "url('https://via.placeholder.com/1200x300') center/cover no-repeat",
        }}
      >
      </div>

      {/* Profile Photo Section */}
      <div>
        <div
          style={{
            position: "relative",
            textAlign: "center",
            marginTop: "-75px",
          }}
        >
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              src={
                nftData !== null
                  ? nftData.imageUri
                  : "https://via.placeholder.com/150/cccccc/808080?text=Profile"
              }
              alt="Profile"
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                border: "2px solid black",
                objectFit: "cover",
              }}
            />
          </div>
          <h2 style={{ margin: "10px 0" }}>{contractData?.fractionalTokenName}</h2>


        </div>

      </div>
    </div>
  );
};

export default IDOBackground;
